module.exports = __webpack_public_path__ + "static/media/oblong_i.bc31de3a.svg";